import { Typography } from 'antd';
import { Col, Row } from 'antd/lib/grid';
import { IViewInvoiceDetails } from '../../../common/types/commonInterfaces';
import { FormatDate } from '../../../common/utils/common.utils';

type Props = { invoice_info: IViewInvoiceDetails };

const ClientInfo = ({ invoice_info }: Props) => {
  const {
    client_address,
    client_email,
    client_mobile,
    client_name,
    invoice_no,
    invoice_sales_date,
    employee_full_name,
    invoice_date,
  } = invoice_info;

  return (
    <Row justify={'space-between'} align='middle'>
      <Col
        style={{
          color: '#fff',
        }}
      >
        <Typography.Title level={5}>INVOICE TO</Typography.Title>
        {client_name && (
          <Typography.Text
            style={{
              display: 'block',
              fontSize: '12px',
              fontFamily: "'Source Sans Pro', sans-serif",
            }}
          >
            Name : {client_name}
          </Typography.Text>
        )}
        {client_address && (
          <Typography.Text
            style={{
              display: 'block',
              fontSize: '12px',
              fontFamily: "'Source Sans Pro', sans-serif",
            }}
          >
            Address : {client_address}
          </Typography.Text>
        )}
        {client_email && (
          <Typography.Text
            style={{
              display: 'block',
              fontSize: '12px',
              fontFamily: "'Source Sans Pro', sans-serif",
            }}
          >
            Email : {client_email}
          </Typography.Text>
        )}
        {client_mobile && (
          <Typography.Text
            style={{
              display: 'block',
              fontSize: '12px',
              fontFamily: "'Source Sans Pro', sans-serif",
            }}
          >
            Mobile : {client_mobile}
          </Typography.Text>
        )}
      </Col>

      <Col className='p-10'>
        <Typography.Text
          style={{
            display: 'block',
            fontSize: '12px',
            fontFamily: "'Source Sans Pro', sans-serif",
          }}
        >
          Invoice No: {invoice_no}
        </Typography.Text>
        <Typography.Text
          style={{
            display: 'block',
            fontSize: '12px',
            fontFamily: "'Source Sans Pro', sans-serif",
          }}
        >
          Invoice Date : {FormatDate(invoice_date)}
        </Typography.Text>

        <Typography.Text
          style={{
            display: 'block',
            fontSize: '12px',
            fontFamily: "'Source Sans Pro', sans-serif",
          }}
        >
          Sales Date : {FormatDate(invoice_sales_date)}
        </Typography.Text>
        <Typography.Text
          style={{
            display: 'block',
            fontSize: '12px',
            fontFamily: "'Source Sans Pro', sans-serif",
          }}
        >
          Sales By : {employee_full_name}
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default ClientInfo;
